(function() {
	'use strict';

	function initSlider () {
		return tns({
			container: document.querySelector('.slider'),
			autoplay: true,
			autoplayButton: false,
			autoplayHoverPause: true,
			items: 1,
			nav: true,
			controls: false,
			mouseDrag: true
		});
	}
	initSlider();
	document.addEventListener('Neos.PageLoaded', function(event) {
		initSlider();
	}, false);
}());
